<template>
  <div>
    <div class="d-flex">
      <div
        is="router-link"
        v-for="(tab, index) in tabs"
        :key="index"
        class="client__tab client__tab--root px-5 py-2 d-inline-block border border-gray border-bottom-0"
        :class="{'border-right-0': notLast(index)}"
        :to="tab.path"
      >
        <slot name="tab">
          {{ tab.title }}
        </slot>
      </div>

      <slot />

      <div class="ml-auto w-25 mb-1">
        <slot name="right">
          <!-- <div class="border-bottom border-dark text-right">
            <img src="/img/icon-search.svg" alt style="transform: translateY(-5px);">
          </div>-->
        </slot>
      </div>
    </div>
    <div
      v-if="hasRouterView && $route"
      class="bg-white border border-gray"
    >
      <router-view :key="$route.fullPath" />
    </div>
  </div>
</template>

<script type="text/javascript">
export default {
  name: 'Tabs',
  props: {
    tabs: {
      type: Array,
      required: true,
    },
    hasRouterView: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    notLast(index) {
      // before return index != this.tabs.length - 1;
      return index !== this.tabs.length - 1;
    },
  },
};
</script>
<style lang="scss" scoped>
.client__tab {
  background-color: rgba(white, 0.5);
  transition: all 0.3s;
}
.router-link-exact-active {
  background-color: white;
}
</style>
